import { schema } from 'normalizr';
import pick from 'lodash/pick';
import get from 'lodash/get';

import { parseDbString } from 'utils/textFormats';
import { getAbsoluteNonAppUrl } from 'utils/resolveUrl';

export const ENTITIES_KEY_EVENT = 'events';

const VIEW_URL_BASE = '/sites/view/';

export const VIRTUAL_TYPE = 'virtual';
export const IN_PERSON_TYPE = 'in-person';
export const HYBRID_TYPE = 'virtual,in-person';

export const EVENT_DEFAULTS = {
    emailTemplateCount: 0,
    eventStageCount: 0,
    imageUrl: '', // dont have fallback yet
    eventUrl: null,
    isEditable: false,
};

// will be different depending on table column settings!!!!
// How to customize that? Hmm

export const VALID_EVENT_KEYS = [
    'id',
    'title',
    'description',
    'organization',
    'eventStart',
    'eventEnd',
    'venueName',
    'address',
    'city',
    'state',
    'zipCode',
    'country',
    'createdAt',
    'modifiedAt',
    'paidForDomain',
    'customDomain',
    'deleted',
    'domain',
    'fqUrl',
    'attendanceTypes',
];

export function getIsVirtual(attendanceTypes = []) {
    return attendanceTypes.length === 1 && attendanceTypes[0] === VIRTUAL_TYPE;
}

export const isValidEventKey = (key) => VALID_EVENT_KEYS.indexOf(key) !== -1;

// Need to remove everything not being used!!! Saving space
// -- do the same in themes. Also, move theme fetch so it doesnt happen until themes dash opened
export const processEvent = (eventData) => {
    const parsedEventData = pick(eventData, VALID_EVENT_KEYS);

    parsedEventData.eventCard = get(eventData, 'eventSetting.eventCards.x2', null);
    parsedEventData.rsvpMethod = get(eventData, 'eventSetting.rsvpMethod', null);

    parsedEventData.lat = get(eventData, 'eventSetting.lat', null);
    parsedEventData.lng = get(eventData, 'eventSetting.lng', null);

    parsedEventData.title = parseDbString(parsedEventData.title);
    parsedEventData.city = parseDbString(parsedEventData.city);
    parsedEventData.address = parseDbString(parsedEventData.address);

    let eventUrl = parsedEventData.fqUrl;
    if (eventUrl.indexOf('splashthat')) {
        eventUrl = eventUrl.replace('https://', VIEW_URL_BASE);
    }
    parsedEventData.eventUrl = getAbsoluteNonAppUrl(eventUrl);

    if (eventData.splashTheme) {
        parsedEventData.themeName = eventData.splashTheme.name;
    }

    return parsedEventData;
};

export const eventSchema = new schema.Entity(
    ENTITIES_KEY_EVENT,
    {},
    {
        processStrategy: (entity) => processEvent(entity),
    },
);

export const eventsSchema = [eventSchema];
